import { Partner } from "@stories/pages/Home/Partner";

export const PartnerView = () => {
  return<>
   <Partner />
  </>

   ;
};
